import { ErrorPropertiesObject } from 'src/app/models/tasks/tasks-properties/error-properties/error-properties-object.model';
import { isNullOrUndefined } from 'util';
import { Converter } from '../../converter.interface';
import { Injectable } from '@angular/core';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';

@Injectable({
    providedIn: 'root'
})
export class TaskErrorPropertiesConverter implements Converter<ErrorPropertiesObject>{

    public convert(input: any): ErrorPropertiesObject {

        try {
            if (isNullOrUndefined(input)) return ErrorPropertiesObject.create();

            return new ErrorPropertiesObject(StringUtils.default(input.operation), StringUtils.default(input.activity),
                StringUtils.default(input.error.code), StringUtils.default(input.error.description), input.error.date,
                new Date(input.startDate), OrderStatusObject.createWithStatus(input.status));
        } catch (error) {
            console.error(error);
            return ErrorPropertiesObject.create();
        }
    }
}
